module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/banner/zh-hans-17d7d7cb89ac11ed7784aa44c1e78d4d.jpg";